import { Controller } from "@hotwired/stimulus"
import Sortable from "sortablejs"

// MC-474: drag-and-drop reordering of the Space settings workflows list.
// The Workflow analogue of `boards--sortable-stage`: each row carries a
// `data-slug`, so Sortable keyed on that attribute returns the new slug
// order via `toArray()`. On drop we POST `{ workflow_slugs }` to the
// reorder endpoint; it replies 204 and we leave the DOM where the drop
// placed it. A failure rolls the move back locally so the visible order
// never drifts from the server's.
export default class extends Controller {
  static values = { url: String }
  static targets = ["handle"]

  connect() {
    this.sortable = Sortable.create(this.element, {
      animation: 150,
      handle: "[data-workflows--reorder-target='handle']",
      // Each row renders `data-slug="<workflow.slug>"`; keying on that lets
      // `toArray()` return slugs in the new visual order directly.
      dataIdAttr: "data-slug",
      onStart: () => { this.previousOrder = this.sortable.toArray() },
      onEnd: this.persist.bind(this)
    })
    this.previousOrder = this.sortable.toArray()
  }

  disconnect() {
    if (this.sortable) {
      this.sortable.destroy()
      this.sortable = null
    }
  }

  async persist() {
    const slugs = this.sortable.toArray()
    const response = await fetch(this.urlValue, {
      method: "POST",
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
        "X-CSRF-Token": this.csrfToken()
      },
      body: JSON.stringify({ workflow_slugs: slugs })
    })

    if (!response.ok) {
      // Server rejected the new order — revert the DOM so what the
      // operator sees matches what the server holds.
      this.sortable.sort(this.previousOrder, true)
    } else {
      this.previousOrder = this.sortable.toArray()
    }
  }

  csrfToken() {
    const meta = document.querySelector("meta[name='csrf-token']")
    return meta ? meta.getAttribute("content") : ""
  }
}
